import { DeleteOutlined } from '@ant-design/icons';
import { Form, Input, Select } from 'antd';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { emailAsciiRule, emailFormatRule } from 'app/utils/rules';
import { capitalizeFirstLetter } from 'app/utils/string';

import { FieldValue } from '../FieldView/FieldView';

import styles from './ExtranetContacts.module.scss';
import { POSITION_OPTIONS } from './columns';

type ContactCardProps = {
  isEditMode: boolean;
  displayIndex: number;
  namePath: number;
  onRemove?: () => void;
  canRemove: boolean;
};

export const ContactCard = ({
  isEditMode,
  displayIndex,
  namePath,
  onRemove,
  canRemove,
}: ContactCardProps) => (
  <div className={styles.card}>
    <div className={styles.cardTitle}>Extranet access #{displayIndex + 1}</div>

    <FormLineLayout label="Email" isRequired isInModal>
      <Form.Item
        name={[namePath, 'email']}
        rules={
          isEditMode
            ? [
                { required: true, message: 'Email is required' },
                emailAsciiRule,
                emailFormatRule,
              ]
            : undefined
        }
        validateFirst
        noStyle
      >
        {isEditMode ? (
          <Input type="email" />
        ) : (
          <FieldValue emptyText="∅ empty" />
        )}
      </Form.Item>
      {isEditMode && canRemove && (
        <DeleteOutlined className={styles.deleteIcon} onClick={onRemove} />
      )}
    </FormLineLayout>

    <FormLineLayout label="Position" isInModal>
      <Form.Item name={[namePath, 'position']} noStyle>
        {isEditMode ? (
          <Select placeholder="Select position" options={POSITION_OPTIONS} />
        ) : (
          <FieldValue emptyText="∅ empty" format={capitalizeFirstLetter} />
        )}
      </Form.Item>
    </FormLineLayout>
  </div>
);
